import { Link } from 'react-router-dom'
export function NotFound(){return <section className="inner-page not-found"><span className="gradient-text">404</span><h1>That page drifted away.</h1><Link className="button primary" to="/">Back home</Link></section>}
